import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import type {
  Program, Programs, User, UserResponse, HomeStepperLink, LoanType,
} from '@core/types';

// Consts
import { ROUTE } from '@consts/routes';
import { EVENT_ACTIONS } from '@consts/analytics-events';

// Services
import { TrackingScriptsService } from '@core/helpers/tracking-scripts/tracking-scripts.service';

type HomeResolveData = { data: UserResponse; current_program?: Program };

@UntilDestroy()
@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent implements OnInit, AfterViewInit {

  currentProgram: Program;

  user: User = this.route.snapshot?.data?.data?.user;

  programs: Programs = this.route.snapshot?.data?.data?.programs;

  username: string = this.route.snapshot.params.username;

  partner: string = this.route.snapshot.queryParams.partner;

  loan_type: LoanType;

  constructor(
    private route: ActivatedRoute,
    private trackingService: TrackingScriptsService,
  ) {}

  ngOnInit(): void {
    this.subscribes();
  }

  ngAfterViewInit(): void {
    this.trackingService.send(EVENT_ACTIONS.VIEW_LANDING_PAGE);
  }

  private subscribes(): void {
    this
      .route
      .data
      .pipe(
        untilDestroyed(this),
      )
      .subscribe(({ current_program }: HomeResolveData) => {
        this.currentProgram = current_program;
      });
  }

  get stepperLink(): HomeStepperLink {
    return {
      link: `/${this.username}/${ROUTE.name.STEPPER}`,
      query_params: {
        ...this.route.snapshot.queryParams,
        program: this.currentProgram?.name,
        loan_type: this.loan_type,
      },
    };
  }

}
